import isEqual from 'lodash/isEqual'

import { getCountryCodes } from '@/utils/country/custom-country-mapping'
import { getStoreName } from '@/base/MaUtils'
import { maLogger } from '@/base/logger'
import Store from '@/base/constants/Store'

export function maCountryGuard(to, from, next) {
  const queryClone = { ...to.query }

  // Second check is a workaround for the pages that has no store in both query or params (Featured Apps page)
  const store = queryClone.store || (to.params.trackId && getStoreName(to.params.trackId)) || Object.values(Store).find(s => to.path.includes(s))
  const availableCountryCodes = getCountryCodes(to, store)

  if (queryClone.countryCode && !availableCountryCodes.includes(queryClone.countryCode)) {
    queryClone.countryCode = availableCountryCodes[0]
  }

  if (queryClone.countryFilter && !availableCountryCodes.includes(queryClone.countryFilter)) {
    queryClone.countryFilter = availableCountryCodes[0]
  }

  if (queryClone.countryCodes && Array.isArray(queryClone.countryCodes) && !queryClone.countryCodes.every(c => availableCountryCodes.includes(c))) {
    queryClone.countryCodes = [availableCountryCodes[0]]
  }

  if (!isEqual(to.query, queryClone)) {
    to.query = queryClone
    next(to)
  }
  else {
    maLogger.info(`Route ${to.name} does not use countryCode`)
    next()
  }
}
